const privilegesOptions = {
  true: '0x0000000000000000000000000000000000000000000000000000000000000001',
  false: '0x0000000000000000000000000000000000000000000000000000000000000000',
}
export default privilegesOptions
